module.exports = __webpack_public_path__ + "static/Canela-Thin-91950e1f90599c4adc1977afdedf2a38.woff";